module.exports = {"title":"The Best Time of the Year to Upgrade Your Vehicle!"}